export const UTILITY = {

    importToNumber(inputPrice): number {
        inputPrice = inputPrice.replace('.', '');
        inputPrice = inputPrice.replace('€', '');
        return Number(inputPrice.replace(',', '.'));
    },
    numberToImport(inputPrice: number): string {
        let priceString = inputPrice.toFixed(2) + '';
        priceString = priceString.replace(',', '');
        priceString = priceString.replace('.', ',');
        return priceString + ' €';
    },
    formatPriceToNumber(inputPrice: string, type: number): boolean {
        inputPrice = inputPrice.replace('.', '');
        inputPrice = inputPrice.replace('€', '');
        const price = Number(inputPrice.replace(',', '.'));
        switch (type) {
            case 1:
                return (price <= 20.00);
            case 2:
                return (price >= 20.00 && price <= 50.00);
            case 3:
                return (price >= 50.00 && price <= 100.00);
            case 4:
                return (price >= 100.00);
        }
    },
    syncText(text) {
        if (this.checkText(text)) {
            text = text.replace(new RegExp('\'', 'g'), '\\\'');
        }
        return text;
    },

    syncPrice(price) {
        if (this.checkText(price) && price.match(this.regexPrice2) !== null) {
            price = price.substring(0, price.length - 1);
            price = price + ' €';
        }
        return price;
    },

    checkText(value): boolean {
        return value !== null && value !== undefined && (value + '') !== '';
    },

    checkObj(value): boolean {
        return value !== null && value !== undefined;
    },

    importToIntNumber(inputPrice): number {
        inputPrice = inputPrice.replace('.', '');
        inputPrice = inputPrice.replace('€', '');
        inputPrice = Number(inputPrice.replace(',', '.'));
        return Math.floor(inputPrice);
    }
};
